module.exports = vendor_0cd2a688cc028415d9bf;